<template>
  <b-modal @hide="modalClose" ref="componentPartsModal" :title="$t('構成部品表')" size="xl">
    <b-container fluid>
      <table class="table table-bordered my-3">
        <colgroup>
          <col width="15%" />
          <col width="15%" />
          <col width="15%" />
          <col width="15%" />
          <col width="7%" />
          <col width="11%" />
          <col width="7%" />
          <col width="15%" />
        </colgroup>
        <thead class="thead">
          <tr>
            <th class="table-active text-left">{{ $t('品番') }}</th>
            <th class="table-active text-left">{{ $t('品名') }}</th>
            <th class="table-active text-left">{{ $t('親品番') }}</th>
            <th class="table-active text-left">{{ $t('親品名') }}</th>
            <th class="table-active text-left">{{ $t('階') }}</th>
            <th class="table-active text-left">{{ $t('数量') }}</th>
            <th class="table-active text-left">{{ $t('単位') }}</th>
            <th class="table-active text-left">{{ $t('使用工程') }}</th>
          </tr>
        </thead>
        <tbody class="tbody">
          <tr>
            <td>
              <template v-if="!isEmpty(mixinIdKeyDisplay('products',Number(structures.productId),'code'))">
                {{ mixinIdKeyDisplay('products',Number(structures.productId),'code') }}
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>
              <template v-if="!isEmpty(mixinIdKeyDisplay('products',Number(structures.productId),'name'))">
                {{ mixinIdKeyDisplay('products',Number(structures.productId),'name') }}
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>-</td>
            <td>-</td>
            <td>0</td>
            <td>1</td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr v-for="(item, index) in structuresArray" :key="index">
            <td>
              <template v-if="!isEmpty(item.productCode)">
                {{ item.productCode }}
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>
              <template v-if="!isEmpty(item.productName)">
                {{ item.productName }}
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>
              <template v-if="!isEmpty(item.productCode)">
                {{ item.productCode }}
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>
              <template v-if="!isEmpty(item.parentProductName)">
                {{ item.parentProductName }}
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>
              <template v-if="!isEmpty(item.level)">
                {{ item.level }}
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>
              <input v-model.number="item.quantity" @input="changeValue(item,'quantity')" min="0" type="number" class="form-control">
            </td>
            <td>
              <template v-if="!isEmpty(item.outputLevel)">
                {{ item.outputLevel }}
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td>
              <select v-model.number="item.productProcessId" @change="changeValue(item,'productProcessId')" class="form-control">
                <option value="-1">-</option>
                <option v-for="(item, index) in processes" :key="index" :value="item.id">{{item.sort}}.{{ $t(mixinProcessKindDisplay(item.processKindId)) }}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    structures: {
      type: Object,
    },
    processes: {
      type: Array,
    },
    processKinds: {
      type: Array,
    },
  },
  data() {
    return {
      form: {},
      structuresArray: [],
      error: '',
      registering: false,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen() {
      this.form = this.mixin_deepcopy(this.structures)
      this.form.productId = Number(this.form.productId)
      this.structuresArray = this.shapingOneArray()
      this.$refs.componentPartsModal.show()
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$refs.componentPartsModal.hide()
      this.$emit('modalClose')
    },
    shapingOneArray() {
      let oneArray = []
      const arrayMap = (item, level) => {
        level++
        item.structures.map(structure => {
          structure.level = level
          structure.parentProductId = item.productId
          oneArray.push(structure)
          if (structure.structures.length !== 0) arrayMap(structure, level)
        })
        if (level > 0) level--
      }
      if (!this.structures.productId) return []
      arrayMap(this.mixin_deepcopy(this.structures), 0)
      return oneArray
    },
    // 値が変わったものをformに反映させる
    changeValue(item, key) {
      let breakFlag = false
      const arrayMap = (array) => {
        array.map(structure => {
          if (breakFlag) return
          if (structure.id === item.id) {
            structure[key] = item[key]
            breakFlag = true
          }
          if (structure.structures.length !== 0 && !breakFlag) arrayMap(structure.structures)
        })
      }
      arrayMap(this.form.structures)
    },
    // 登録処理
    async register() {
      let errorFlag = false
      this.structuresArray.map(item => {
        if (!item.quantity && !errorFlag) {
          errorFlag = true
          this.error = this.$t('数量は0より大きい数字を入力して下さい')
        }
        if (item.quantity <= 0 && !errorFlag) {
          errorFlag = true
          this.error = this.$t('数量は0より大きい数字を入力して下さい')
        }
      })
      if (errorFlag) {
        return
      } else {
        this.error = ''
      }
      this.registering = true
      const arrayMap = (array) => {
        array.map(structure => {
          for (let key of Object.keys(structure)) {
            if (structure[key] == null) {
              structure[key] = -1
            }
          }
          if (!structure.structures) return
          if (structure.structures.length !== 0) arrayMap(structure.structures)
        })
      }
      arrayMap(this.form.structures)
      try {
        await this.$axios.put(
          `${this.$appConfig.CommonApiUrl}/product/structure`,
          this.form,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.$toasted.success(`${this.$t('データ登録完了メッセージ')}`)
        this.$refs.componentPartsModal.hide()
        this.$emit('registered')
      } catch (error) {
        this.$toasted.show(`${this.$t('データ登録エラーメッセージ')}`)
      }
      this.registering = false
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
]
